import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import fr from 'facet-rest';

const useStyles = buildUseStyles('HoldingsSectionContent', (theme) => ({
  root: {},
  title: {},
  holdingsSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  holdingsSectionLine: {
    marginBottom: theme.spacing(2),
  },
  holdingsLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  holdingsName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  percentage: {
    marginLeft: theme.spacing(1),
  },
}));

const HoldingsSectionContent = ({
  className,
  holdingsCollection,
  color,
}) => {
  const [holdingsBreakdownResource] = holdingsCollection;
  const holdingsSectionsCollection = fr.collection(holdingsBreakdownResource.attr('holdingSections'));

  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {holdingsSectionsCollection.resources().list().map(section => (
        <Box key={`${section.id()}-${section.attr('name')}`} className={classes.holdingsSection}>
          <Box className={classNames(classes.holdingsSectionLine, classes.holdingsLine)}>
            <Text
              variant={'h6'}
              color={color}
              text={section.attr('name')}
            />
            <Text
              className={classes.percentage}
              variant={'h6'}
              color={color}
              text={section.attr('percentage')}
            />
          </Box>
          {section.attr('holdings')?.map(holding => {
            const holdingResource = fr.resource(holding);
            return (
              <Box key={`${holdingResource.id()}-${holdingResource.attr('name')}`} className={classes.holdingsLine}>
                <Text
                  className={classes.holdingsName}
                  variant={'body'}
                  weight={'book'}
                  color={'primaryGray'}
                  text={holdingResource.attr('name')}
                />
                <Text
                  className={classes.percentage}
                  variant={'body'}
                  weight={'book'}
                  color={'primaryGray'}
                  text={holdingResource.attr('percentage')}
                />
              </Box>
            );
          })}
        </Box>
      ))}
    </Box>
  );
};

HoldingsSectionContent.defaultProps = {
  className: '',
  color: 'primary',
};

HoldingsSectionContent.propTypes = {
  className: PropTypes.string,
  holdingsCollection: PropTypes.instanceOf(fr.Collection).isRequired,
  color: PropTypes.string,
};

export default HoldingsSectionContent;
